import { useModel } from '../model'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'
import useGlobalModel from "@/model/globalModel";

export function PageHeader() {
    const { shopAndOrg: { shopType }, allShopDs } = useGlobalModel();
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = useModel()

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '商品编码',
            fieldName: 'materialCode',
            span: 4,
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: '商品名称',
            fieldName: 'materialName',
            span: 4,
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "是否下限预警",
            fieldName: "limitLowerUrgencyFlag",
            options: [{ label: "是", value: 1 }, { label: "否", value: 0 }],
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "是否上限预警",
            fieldName: "limitUpperUrgencyFlag",
            options: [{ label: "是", value: 1 }, { label: "否", value: 0 }],
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     placeholder: "所属站点",
        //     fieldName: "shopId",
        //     options: allShopDs,
        //     disabled: shopType === 0 ? false : true
        // },
    ]

    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    )
}
